import {
  formatHubSettingsDirectionLabel,
  IHubSettingsGridItem,
  isHubSettingsDirection,
} from "@ryde/shared";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

const isHubSettingsGridItem = (
  value: unknown,
): value is IHubSettingsGridItem => {
  if (!isRecord(value)) {
    return false;
  }

  const { hubStationId, stationId, hubStationName, stationName, direction } =
    value;

  return (
    typeof hubStationId === "number" &&
    hubStationId > 0 &&
    typeof stationId === "number" &&
    stationId > 0 &&
    typeof hubStationName === "string" &&
    hubStationName.length > 0 &&
    typeof stationName === "string" &&
    stationName.length > 0 &&
    (direction === undefined || isHubSettingsDirection(direction))
  );
};

export const formatHubSettingsItemText = (
  item: IHubSettingsGridItem,
): string => {
  const directionLabel = item.direction
    ? ` (${formatHubSettingsDirectionLabel(item.direction)})`
    : "";
  return `${item.hubStationId} ${item.hubStationName} - ${item.stationId} ${item.stationName}${directionLabel}`;
};

export const formatHubSettingsCellSummary = (
  items: IHubSettingsGridItem[],
): string => {
  return items.map(formatHubSettingsItemText).join(", ");
};

export const parseHubSettingsGridItems = (
  value: unknown,
): IHubSettingsGridItem[] => {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter(isHubSettingsGridItem);
};
